window.VegasCatalog.Filters = {
	container: 'vg-catalog-filters',
	set: 'vg-catalog-filters__item',
	box: 'vg-catalog-filters__item--body',
	filter: 'vg-catalog-checkbox--label',
	form: '#catalog-filter-form',
	numCheckAll: 5,
	numCheckSearch: 15,
	showCheckAll: true,
	showCheckSearch: true,
	inputs: {},

	// Инициализируем
	init: function () {
		let $sets = $('.' + VegasCatalog.Filters.container).find('.' + VegasCatalog.Filters.set);

		if($sets.length) {
			$sets.each(function () {
				let $filter = $(this),
					type = $filter.data('type') ;

				if (type === 'checkbox') {
					let $checkboxes = $filter.find('.' + VegasCatalog.Filters.box).find('.' + VegasCatalog.Filters.filter);
					if ($checkboxes.length >= VegasCatalog.Filters.numCheckSearch && VegasCatalog.Filters.showCheckSearch) {
						$filter.find('[data-filter-panel=search]').show();
					}

					if ($checkboxes.length >= VegasCatalog.Filters.numCheckAll && VegasCatalog.Filters.showCheckAll) {
						$filter.find('[data-filter-panel=checkAll]').show();
					}
				} else if (type === 'range') {
					let $ranges = $($filter).find(".range-slider-filters");
					if ($ranges.length) {
						$ranges.each(function () {
							VegasCatalog.Filters.range($(this), true);
						});
					}
				} else if (type === 'color') {
					let $colors = $($filter).find('.vg-catalog-filters__item--colors .list-item');

					$colors.each(function () {
						VegasCatalog.Filters.colors($(this), true);
					});
				}
			});
		}

		VegasCatalog.Filters.getInputs();
		VegasCatalog.Filters.selectedSet();
	},

	// Чекаем параметр фильтра
	check: function ($checkbox) {
		if (!$checkbox.hasClass('checkAll')) {
			$checkbox.toggleClass('checked');
		} else {
			let $container = $checkbox.closest('.' + VegasCatalog.Filters.set),
				$boxes = $container.find('.' + VegasCatalog.Filters.box).find('.' + VegasCatalog.Filters.filter + ':visible');

			if ($checkbox.hasClass('checked')) {
				$boxes.removeClass('checked');
				$checkbox.removeClass('checked');
			} else {
				$boxes.addClass('checked');
				$checkbox.addClass('checked');
			}
		}

		let $set = $checkbox.closest('.' + VegasCatalog.Filters.set),
			$checked_params = $set.find('.' + VegasCatalog.Filters.box).find('.checked');

		if ($set.data('param') in VegasCatalog.Filters.inputs) {
			delete VegasCatalog.Filters.inputs[$set.data('param')];
		}

		if ($checked_params.length) {
			let arr = [];

			$checked_params.each(function () {
				arr.push($(this).data('value'));
			});

			VegasCatalog.Filters.inputs[$set.data('param')] = arr.join();
		}

		if ($set.has('[data-trigger]') && $set.data('trigger') === 'submit') {
			VegasCatalog.Filters.submit();
		}
	},

	radio: function ($checkbox) {
		let $set = $checkbox.closest('.' + VegasCatalog.Filters.set),
			$checked_params = $set.find('.' + VegasCatalog.Filters.box).find('.checked');

		$checked_params.removeClass('checked');
		$checkbox.addClass('checked');

		VegasCatalog.Filters.inputs[$set.data('param')] = $checkbox.data('value');

		if ($set.has('[data-trigger]') && $set.data('trigger') === 'submit') {
			VegasCatalog.Filters.submit();
		}
	},

	range: function ($self, slider = false) {
		if (!slider) {
			let type = $self.data('number'),
				$range = $self.closest('.' + VegasCatalog.Filters.container).find('.range-slider-filters'),
				$slider = $range.data("ionRangeSlider"),
				val = parseInt($self.val()) || null;

			if (val !== null) {
				if (type === 'from') {
					$slider.update({
						from: val
					});
				}

				if (type === 'to') {
					$slider.update({
						to: val
					});
				}

				let param = $self.closest('.' + VegasCatalog.Filters.set).data('param');
				VegasCatalog.Filters.inputs[param] = $range.data('from') + ',' + $range.data('to');
			}
		} else {
			$self.ionRangeSlider({
				skin: "round",
				onChange: function (data) {
					$self.closest('.' + VegasCatalog.Filters.set + '--range').find('[data-number=from]').val(data.from);
					$self.closest('.' + VegasCatalog.Filters.set + '--range').find('[data-number=to]').val(data.to);

					let param = $self.closest('.' + VegasCatalog.Filters.set).data('param');
					VegasCatalog.Filters.inputs[param] = data.from + ',' + data.to;
				}
			});
		}

		return false;
	},

	colors: function ($color, scatter = false) {
		if (scatter) {
			let colors = $color.data('value').split(':');

			for(let i = 1; i <= colors.length; i++) {
				$color.append('<div style="background-color: #'+ colors[i - 1] + '"></div>')
			}
		}
	},

	// Поиск параметра
	search: function ($self) {
		let $filter = $self.closest('.' + VegasCatalog.Filters.set),
			$val = $filter.find('[data-value]'),
			val = $self.val();

		$val.show();

		if (val.length) {
			val = $.trim(val);
			val = val.toLowerCase();
			let vals = [
				val,
				transliterate(val, false),
				transliterate(val, true),
				translit(val),
				translit(val, true),
			];

			$filter.find('[data-value]').filter(function () {
				let param = $(this).text().toLowerCase();

				return vals.filter(function (element) {
					return param.indexOf(element) !== -1;
				}).length === 0;
			}).hide();
		}

		return false;
	},

	selectedSet: function () {
		let $filters = $('.' + VegasCatalog.Filters.container).find('.' + VegasCatalog.Filters.set);

		$filters.each(function () {
			let $_self = $(this),
				set = $_self.data('set'),
				type = $_self.data('type');

			if (set === 'multiple') {
				let param = $_self.data('param'),
					inputs = VegasCatalog.Filters.getInputs(param);

				if (inputs && inputs.length) {
					inputs = inputs.split(',');

					if (type === 'checkbox' || type === 'radio') {
						$_self.find('.' + VegasCatalog.Filters.box).find('.checked').removeClass('checked');

						$.each(inputs, function (key, value) {
							$_self.find('[data-value=' + value + ']').addClass('checked');
						});

						if (inputs.length === $_self.find('.' + VegasCatalog.Filters.filter +':not(.checkAll)').length) {
							$_self.find('.' + VegasCatalog.Filters.filter + '.checkAll').addClass('checked')
						}
					}
				}
			} else if(set === 'select' || set === 'single') {
				let param = $_self.data('param'),
					inputs = VegasCatalog.Filters.getInputs(param),
					$checked_value = $_self.find('[data-value="'+ inputs +'"]');

				$_self.find('.checked').removeClass('checked');
				$checked_value.addClass('checked');
			}
		});
	},

	// Получаем параметры
	getInputs: function (param = false) {
		VegasCatalog.Filters.inputs = $('.' + VegasCatalog.Filters.container).data('url-json');

		if (VegasCatalog.Filters.inputs.length === 0) VegasCatalog.Filters.inputs = {};

		if (param) {
			return VegasCatalog.Filters.inputs[param];
		}

		return VegasCatalog.Filters.inputs;
	},

	setInputs: function () {
		let inputs = VegasCatalog.Filters.inputs,
			$form = $(VegasCatalog.Filters.form);

		if (!inputs) inputs = {};

		$form.find('input').remove();

		if (Object.keys(inputs).length > 0) {
			function appendInputs(objects) {
				$.each(objects, function (key, value) {
					if (value !== '' && typeof value !== 'object') {
						$form.append('<input type="hidden" name="' + key + '" value="' +  value + '">');
					} else if (typeof value === 'object' && Object.prototype.toString.call(value) !== '[object Array]') {
						appendInputs(value);
					} else if (Object.prototype.toString.call(value) === '[object Array]') {
						let val = value.join(',');
						$form.append('<input type="hidden" name="' + key + '" value="' +  val + '">');
					}
				});
			}

			appendInputs(inputs);
		}

		return true;
	},

	submit: function () {
		VegasCatalog.Filters.setInputs();
		$(VegasCatalog.Filters.form).trigger('submit');
	},

	clearFilter: function ($_self) {
		let $filter = $_self.closest('.' + VegasCatalog.Filters.set),
			set = $filter.data('set');

		if (set === 'single') {
			let param = $filter.find('[data-param]').data('param');

			delete VegasCatalog.Filters.inputs[param];
			VegasCatalog.Filters.setInputs();

			return VegasCatalog.Filters.submit();
		}

		if (set === 'multiple') {
			let param = $filter.find('[data-param]').data('param');

			$filter.find('.selected').removeClass('selected');
			delete VegasCatalog.Filters.inputs[param];
			VegasCatalog.Filters.setInputs();

			return VegasCatalog.Filters.submit();
		}

		return false;
	}
};

/**
 * Слушаем события
 */
$(document).ready(function () {
	if ($('.' + VegasCatalog.Filters.container).length) {
		VegasCatalog.Filters.init();
	}

	$(document).on('click', '[data-toggle=filter-check]', function () {
		if ($(this).hasClass('radio')) {
			VegasCatalog.Filters.radio($(this));
		} else {
			VegasCatalog.Filters.check($(this));
		}

		return false;
	});

	$('.'+ VegasCatalog.Filters.set + ' [name=search-filter]').on('keyup change', function () {
		return VegasCatalog.Filters.search($(this));
	});

	$('.range-input').on('input keyup', function () {
		VegasCatalog.Filters.range($(this));
		return false
	});

	$(document).on('click', '.vg-catalog-filters__submit', function () {
		$(this).attr('disabled', true).addClass('disabled');

		VegasCatalog.Filters.submit();

		return false;
	});

});